import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Masonry from "@mui/lab/Masonry";
import { styled, StyledEngineProvider } from "@mui/material/styles";
import q1 from "../../assets/images/q1.jpg";
import q2 from "../../assets/images/q2.jpg";
import q3 from "../../assets/images/q3.jpg";
import q4 from "../../assets/images/q4.jpg";
import q5 from "../../assets/images/q5.jpg";
import PinterestLayout from "src/components/PinterestLayout/Pinterest";

function Quotes() {
  const itemData = [];
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <h2 className="quotes-heading margin-quotes">Quotes</h2>
          </div>
          <div className="col-6">
            {/* <button
              className="small-contained-button float-end"
              onClick={handleChange}
            >
              ADD GRATITUDE
            </button> */}
          </div>
        </div>
      </div>
      <PinterestLayout data={itemData} />
      {/* <div className="grid-container">
        <h2>Quotes</h2>
      </div>

      <div className="grid-container mt-4">
        {itemData.map((value, index) => {
          console.log(value, "data of map");
          return (
            <div>
              <img className="grid-item" src={value.img} alt="" />
              <p>{value.description}</p>
            </div>
          );
        })}
      </div> */}
    </>
  );
}

export default Quotes;
